import { useTranslation } from 'react-i18next';

interface TOCItem {
  id: string;
  title: string;
}

export function ArticleTOC({ sections }: { sections: TOCItem[] }) {
  const { i18n } = useTranslation();
  if (sections.length === 0) return null;

  return (
    <nav className="article-toc" aria-label="Table of contents">
      <h2 className="text-sm font-semibold text-muted-foreground mb-4">{i18n.language.startsWith('fr') ? 'Dans ce guide' : 'In this guide'}</h2>
      <ol className="space-y-1.5 list-none m-0 p-0">
        {sections.map((s, i) => (
          <li key={s.id} className="m-0 p-0">
            <a
              href={`#${s.id}`}
              className="text-sm text-foreground/80 hover:text-primary transition-colors no-underline flex items-baseline gap-2"
            >
              <span className="text-xs text-muted-foreground font-mono">{String(i + 1).padStart(2, '0')}</span>
              {s.title}
            </a>
          </li>
        ))}
      </ol>
    </nav>
  );
}
